import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Box, styled, Button, Container, } from "@mui/material";
import Swal from "sweetalert2";
import { RouteImage } from "../constants/RouteImage";
import * as styles from './HotpitalStyle'
import axios from "axios";
import { useParams } from "react-router-dom";
import { Col, Row } from 'react-bootstrap'
import Loading from "react-loading";
import '../App.css';
import { Block, FamilyRestroom } from "@mui/icons-material";

const IsHospital = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idcard = location?.state?.idcard
  const random = location?.state?.random
  const initData = location?.state?.data

  const [data, setData] = useState(initData);
  const [isLoading, setIsLoading] = useState(false);
  const [healthData, setHealthData] = useState({});
  const [healthSubData, setHealthSubData] = useState({});
  const [fullname, setFullname] = useState([]);
  const [options, setOptions] = useState('');
  const [dates, setDates] = useState({});
  const [activeIndex, setActiveIndex] = useState([]);
  const [defaultState, setDefaultState] = useState(false);

  const tokens = "32a9fcf38fb1aebaed";
  const bodyCondition = {
    idcard: idcard,
    getdata: "all",
    randomToken: random
  }

  const handleGetData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        "https://api.myhealthgroup.net/apiservice/thg/gethealthhistorylist",
        bodyCondition,
        {
          headers: {
            Authorization: `Bearer ${tokens}`,
          },
        }
      );

      if (response.status === 200) {
        setData(response.data?.payload);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const labeldata = () => {
    let fullNameList = [];
    data?.map((item, index) => {
      if (item?.fullname && !fullNameList.includes(item?.fullname)) {
        fullNameList.push(item?.fullname);
      }
    })
    return (
      <>
        <div className="nav-name">
          {fullNameList[0] && <div className="nav-name"> {fullNameList[0]}</div>}
        </div>
      </>
    )
  }




  const prepareData = () => {

    const maphealthdata = (index) => {
      if (healthSubData?.[index]) {
        return (

          <div className="hide-box">
            {healthSubData?.[index]?.detail?.clinicdate && (<div className="text-header">ณ วันที่ตรวจ : {healthSubData?.[index]?.detail?.clinicdate}</div>)}
            {healthSubData?.[index]?.vitalsign && (<div className="labVitalsign"><b>Vitalsign</b> : {healthSubData?.[index]?.vitalsign.map((item, index) => {
              return (
                <div className="textHealthData">
                  {item?.bp && <span className="span-style">bp: {item?.bp}</span>}
                  {item?.datevisit && <span className="span-style">datevisit: {item?.datevisit}</span>}
                  {item?.height && <span className="span-style">height: {item?.height}</span>}
                  {item?.hn && <span className="span-style">hn: {item?.hn}</span>}
                  {item?.pr && <span className="span-style">pr: {item?.pr}</span>}
                  {item?.weight && <span className="span-style">weight: {item?.weight}</span>}
                </div>
              )
            })}
            </div>)}
            {healthSubData?.[index]?.labresult.length ? (<div className="labResult"><b>LabResult</b> : {healthSubData?.[index]?.labresult.map((item, index) => {
              return (
                <div className="textHealthData">
                  <span>{item?.thname ?? item?.enname} : {item?.value}</span>
                  {item?.goodrange && <span> (ค่าปกติ : {item?.goodrange})</span>}
                  {item?.comment && <span> {item?.comment}</span>}
                </div>
              )
            })}
            </div>) : <div className="labResult"><b>LabResult</b> : ไม่พบข้อมูล</div>}

            {healthSubData?.[index]?.medicine.length ? (<div className="labMedicine"><b>Medicine</b> : {healthSubData?.[index]?.medicine.map((item, index) => {
              return (
                <div className="textHealthData">

                  {item?.name && <span> {item?.name} </span>}
                  {item?.note.instruction && <span> ({item?.note.instruction}) </span>}
                </div>
              )
            })}
            </div>) : <div className="labMedicine"><b>Medicine</b> : ไม่พบข้อมูล</div>}

            {healthSubData?.[index]?.daignosis.length ? (<div className="labdaignosis"><b>Daignosis</b> : {healthSubData?.[index]?.daignosis.map((item, index) => {
              return (
                <div className="textHealthData">

                  <div>
                    {item?.code && <span className="textHealthData">code : {item?.code} </span>}
                    {item?.desc && <span className="textHealthData">|| desc : ({item?.desc}) </span>}
                  </div>
                </div>
              )
            })}
            </div>) : <div className="labdaignosis"><b>Daignosis</b> : ไม่พบข้อมูล</div>}
          </div>
        );
      } else {
        return (Loading);
      }
    }

    let tempData = data

    if (Object.keys(dates).length > 0) {

      tempData = tempData?.filter((item) => item?.clinicdate == dates)


    }
    if (options != '') {
      tempData = tempData?.filter((item) => item?.source == options)
    }
    return (
      tempData?.map((item, index) => {
        return (
          <div className="header" key={'id' + index}>
            <div className="cards" >
              <div className="card main" >
                {item?.partner?.name?.th && (
                  <div className="tip">{item.partner.name.th}</div>
                )}
                {item?.source && <div className="second-text">ข้อมูล : {item.source}</div>}
                {item?.title && <div className="second-text">แผนก : {item.title}</div>}
                {item?.diag && <div className="second-text">{item.diag}</div>}
                {item?.docname && (
                  <div className="second-text">แพทย์ผู้ตรวจ : {item.docname}</div>
                )}
                {item?.clinicdate && (
                  <div className="second-text">ณ วันที่ : {item.clinicdate}</div>
                )}
                {item?.name && <div className="second-text">ข้อมูลวัคซีน : {item.name}</div>}
                {item?.vaccinetype && (
                  <div className="second-text">ชนิดวัคซีน : {item.vaccinetype}</div>
                )}
                {item?.orderdate && (
                  <div className="second-text"> ณ วันที่ : {item.orderdate}</div>
                )}
                <img src={'https://file.myhealthgroup.net/public/usr_img/' + item?.partner?.icon} className="logo" />
                {item?.source != 'vaccine' ?
                  (
                    <div className="box-in">
                      <button style={{ backgroundColor: activeIndex.includes(index) ? '#5382c2' : '' }}
                        className="btnHpt"
                        onClick={() => {
                          handleHealthData(index, item);
                          toggleActiveIndex(index);
                          setDefaultState(true);
                        }} >View Details
                        <img className="btnIcon" style={{
                          transform: activeIndex.includes(index) ? 'rotate(360deg)' : '',
                        }} src="/image/arrow.png" />
                      </button>
                    </div>
                  ) : null}
              </div>
              {healthData[index] && <div className="card-hide">{maphealthdata(index)}</div>}
            </div>
          </div>

        )
      }
      )
    );
  };

  const toggleActiveIndex = (index) => {
    if (activeIndex.includes(index)) {
      setActiveIndex(activeIndex.filter((i) => i !== index));
    } else {
      setActiveIndex([...activeIndex, index]);
    }
  };

  const getHealthSubData = async (index, item) => {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer 32a9fcf38fb1aebaed");

    const raw = JSON.stringify({
      "partnerid": item?.partner?.partnerid,
      "clinicdate": item?.clinicdate,
      "reportid": item?.reportid,
      "userid": item?.userid,
      "randomToken": random
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    try {
      const res = await fetch('https://api.myhealthgroup.net/apiservice/thg/gethealthdata', requestOptions)
      if (res.ok) {
        const json = await res?.json()
        const payload = await json?.payload
        setHealthSubData((prevState) => ({
          ...prevState,
          [index]: payload
        }))

      } else {
        alert("No Report Data")
      }

    }
    catch (error) {
      console.log(error)
    }
  }

  const handleHealthData = async (index, item) => {
    if (healthData[index] !== true) {
      await getHealthSubData(index, item)
    }
    setHealthData((prevState) => ({
      ...prevState,
      [index]: !prevState[index]
    }))

  }


  return (

    <styles.SetHospital>
      <div className="nav">
        {isLoading && <p>กรุณารอสักครู่...</p>}
        {!isLoading && <p className="nav-name">ข้อมูลผู้ป่วย : &nbsp;{labeldata()}</p>}

        <button className="btn" onClick={() => navigate(-1)}>
          Back
          <div className="arrow-wrapper">
            <div className="arrow"></div>
          </div>
        </button>
      </div>
      <div className="app-header">
        <div className="cards">
          <div className="search-bar">
            {!isLoading && <input type="date" placeholder="Date" defaultValue={''} className="date" value={dates} onChange={e => setDates(e.target.value)} />}
            {!isLoading &&
              <select className="dropdown" placeholder="type" defaultValue={''} value={options} onChange={e => setOptions(e.target.value)}>
                <option value=''>all </option>
                <option value='opd'>opd</option>
                <option value='check-up'>check-up</option>
                <option value='vaccine'>vaccine </option>

              </select>}
            <br /></div>
        </div>
        <div className="card-header">
          <div className='cards'>
            {prepareData()}
          </div>
        </div>
        {isLoading && <Loading color="#5382c2" type="spin" className="load" />}
      </div>
    </styles.SetHospital>

  );
};
export default IsHospital;
